import { render, staticRenderFns } from "./InfoProductoDialogo.vue?vue&type=template&id=76cddb78"
import script from "./InfoProductoDialogo.vue?vue&type=script&lang=js"
export * from "./InfoProductoDialogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports